import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { languageDetector } from './detector';

import it from '../translations/it-IT.json';
import en from '../translations/en-EN.json';

export type AppTranslations = typeof it;

const resources = {
  it: { app: it },
  en: { app: en },
} as const;

void i18n
  .use(languageDetector as any)
  .use(initReactI18next)
  .init({
    resources,
    ns: ['app'],
    defaultNS: 'app',
    fallbackLng: 'it',
    interpolation: { escapeValue: false },
    returnNull: false,
    pluralSeparator: '_',
  });

export default i18n;
